module.exports = __webpack_public_path__ + "7a20d9f4d91eadcdc5db387a60726bb3.MP3";